const EventConstants = {
  LOGOUT_EVENT: 'logout'
};

export default EventConstants;
